import "core-js/modules/es6.symbol.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
var TitleSection = () => import('~/components/atoms/Editorial/TitleSection.vue');
var SubtitleSection = () => import('~/components/atoms/Editorial/SubtitleSection.vue');
var SimpleParagraph = () => import('~/components/atoms/Editorial/SimpleParagraph.vue');
var MainImage = () => import('~/components/atoms/Editorial/MainImage.vue');
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
var COLORS = {
  grey: 'btn-dark',
  transparent: 'btn-transparent'
};
export default {
  name: 'GlobalDispatchFooter',
  components: {
    TitleSection,
    SubtitleSection,
    SimpleParagraph,
    MainImage,
    MdmLink
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    background() {
      return {
        color: this.payload.primary.background_color || '',
        image: formatPrismicImage(this.payload.primary.image.url) || ''
      };
    },
    title() {
      var type = this.payload.primary.title && this.payload.primary.title[0] && this.payload.primary.title[0].type;
      return {
        text: Object.keys(this.payload.primary.title).length === 0 ? '' : this.payload.primary.title[0],
        color: this.payload.primary.title_color || '',
        type: type || 'heading2'
      };
    },
    subtitle() {
      var type = this.payload.primary.subtitle && this.payload.primary.subtitle[0] && this.payload.primary.subtitle[0].type;
      return {
        text: Object.keys(this.payload.primary.subtitle).length === 0 ? '' : this.payload.primary.subtitle[0],
        color: this.payload.primary.subtitle_color || '',
        type: type || 'heading2'
      };
    },
    simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },
    legals() {
      return this.payload.primary.legals || '';
    },
    elements() {
      return this.payload.items.map(item => {
        var small = formatPrismicImage(item.image.url, ['w_150,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_330,dpr_2']) || EMPTY_PIXEL;
        return {
          src: large,
          srcset: "".concat(small, " 300w, ").concat(large, " 660w"),
          alt: item.alt || '',
          ratioImages: item.ratio_images || '1:1',
          title: Object.keys(item.title).length === 0 ? '' : item.title[0],
          titleColor: item.title_color,
          simpleParagraphItem: item.simple_paragraph_item || [],
          backgroundColor: item.background_color || '',
          button: {
            url: item.button_url.url || '',
            text: item.button_text || '',
            color: COLORS[item.button_color]
          },
          tracking: {
            data: {
              event_category: item.event_category || '',
              event_action: item.event_action || '',
              event_label: item.event_label || ''
            }
          }
        };
      });
    },
    isHeadingTitle() {
      var headingTitles = ['heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6'];
      var type = this.payload.primary && this.payload.primary.simple_paragraph && this.payload.primary.simple_paragraph[0] && this.payload.primary.simple_paragraph[0].type;
      return headingTitles.includes(type);
    },
    buttonFirst() {
      return {
        url: this.payload.primary.button_url1 ? this.payload.primary.button_url1.url : '',
        text: this.payload.primary.button_text1 || '',
        color: COLORS[this.payload.primary.button_color1],
        tracking: {
          data: {
            event_category: this.payload.primary.event_category1 || '',
            event_action: this.payload.primary.event_action1 || '',
            event_label: this.payload.primary.event_label1 || ''
          }
        }
      };
    },
    buttonSecond() {
      return {
        url: this.payload.primary.button_url2 ? this.payload.primary.button_url2.url : '',
        text: this.payload.primary.button_text2 || '',
        color: COLORS[this.payload.primary.button_color2],
        tracking: {
          data: {
            event_category: this.payload.primary.event_category2 || '',
            event_action: this.payload.primary.event_action2 || '',
            event_label: this.payload.primary.event_label2 || ''
          }
        }
      };
    }
  })
};